import config from 'config';
import axios from 'axios';

export default axios.create({
  baseURL: config.apiPath,
  withCredentials: true,
});


// WEBPACK FOOTER //
// ./src/utils/api.js